export default __webpack_public_path__ + "static/hero-iceland-730556cd1ff7748e48f83f8d7f6ba0b2.jpg";